import { InjectableClass } from '@fino/lib-injection';
import _ from 'lodash';

export class NavbarService extends InjectableClass {
  get config() {
    return this.appConfig;
  }

  constructor(
    navbarTabs,
    navbarTabsByProduct,
    ticketsService,
    $timeout,
    userService,
    envService,
    appConfig,
    featureFlagService,
    FeatureFlagNames,
  ) {
    'ngInject';
    super({
      navbarTabs,
      navbarTabsByProduct,
      ticketsService,
      $timeout,
      userService,
      envService,
      appConfig,
      featureFlagService,
      FeatureFlagNames,
    });
  }

  registerTab(tab) {
    if (!tab.id) {
      throw new Error(`The tab to register is missing an id, given: ${tab}`);
    }
    this.navbarTabs[tab.id] = tab;
  }

  updateTab(tabId, options) {
    const { $timeout, navbarTabs } = this;
    $timeout(() => angular.extend(navbarTabs[tabId], options));
  }

  get legacyTabs() {
    return !this.featureFlagService.isFeatureActive(
      this.FeatureFlagNames.FF_SPLIT_BY_SWITCH_PRODUCTS,
    );
  }

  getTabs() {
    const { navbarTabs, config } = this;
    const tabsConfig = _.keys(_.pickBy(config.ui.navbar.tabs));
    const tabs = {};

    // Filter out all tabs that have been deactivated by config
    tabsConfig.forEach((tab) => {
      tabs[tab] = _.find(navbarTabs, { id: tab });
    });

    return this.legacyTabs ? tabs : this.navbarTabsByProduct;
  }
}
